import styles from './InlineGraph.module.scss';

const InlineGraph = ({fontsize = 16, rangeLow, rangeHigh, result = 77}) => {
 const colors = { range: "green", bar: "blue", line: "currentColor", outside: "red"}
 let textPoint = {low: 0, high: 0};
 let rangePercentage = {start: 0, width: 100};
 let resultPercentage = 0;

 function setLineColor() {
   return (rangeLow < rangeHigh && (result < rangeLow || result > rangeHigh)) ? 
        styles.outside : 
        (rangeLow === undefined && result < rangeHigh) ?
            styles.outside :
            (rangeHigh === undefined && result > rangeLow) ?
                styles.outside :
                styles.resultLine
 }

 if (!Number.isFinite(result)) {
    return (<span>lab results not valid</span>);
 } else if (rangeLow === undefined && rangeHigh === undefined) {
    return (<span>not enough data to graph</span>);
 } else if (rangeLow === undefined && rangeHigh !== undefined) {
    // high (should not be higher than this number)
    // - 2/3 range bar; 1/3 plus extra is empty
    rangePercentage = {start: 33, width: 67};
    textPoint = {low: 0, high: 33};
    resultPercentage = result * (rangePercentage.start / rangeHigh);
 }  else if (rangeLow !== undefined && rangeHigh === undefined) {
    // low (should not be lower than this number) 
    // - 1/3 plus extra is empty; 2/3 range bar
    rangePercentage = {start: 0, width: 67};
    textPoint = {low: 67, high: 0};
    resultPercentage = result * (textPoint.low / rangeLow);
 } else {
    // range difference = 1/3+1/3+1/3 (1/3 plus extra given to range bar)
    //const rangeWidth = range.high - range.low;
    rangePercentage = {start: 33, width: 34};
    textPoint = {low: 33, high: rangePercentage.start + rangePercentage.width};
    resultPercentage = rangePercentage.start + ((result - rangeLow) * (textPoint.high - textPoint.low) / (rangeHigh - rangeLow));
 }

 if (resultPercentage < 0) {
    resultPercentage = 1;
 } else if (resultPercentage > 100) {
    resultPercentage = 98;
 }


 const text = result.toString();
 return (
    <svg className={styles.inlineGraph} width="100%" height="65" xmlns="http://www.w3.org/2000/svg">
        <rect className={styles.bar} width="100%" height="25" x="1" y="15" rx="8" ry="8" fill={colors.bar} />
        <rect className={styles.range} width={`${rangePercentage.width}%`} height="25" x={`${rangePercentage.start}%`} y="15" rx="8" ry="8" fill={colors.range} />
        <rect className={setLineColor()} width="3" height="45" x={`${resultPercentage}%`} y="13" fill="currentColor" />

        <text
            className={setLineColor()}
            x={(resultPercentage > 95) ? `${resultPercentage-1.65}%` : `${resultPercentage+1.65}%`}
            y="58"
            textAnchor={(resultPercentage > 95) ? "end" : "start"}
            dominantBaseline="text-after-edge"
            fontSize={fontsize}
            fontWeight="bold"
            fontFamily="sans-serif"
            fill="currentColor"
        >
            {text}
        </text>

        {(rangeLow || rangeLow === 0) && (
        <text
            className={styles.low}
            x={`${textPoint.low}%`}
            y="0"
            textAnchor={textPoint.low > 33 ? "end" : "start"}
            dominantBaseline="text-before-edge"
            fontSize={fontsize-2}
            fontWeight="bold"
            fontFamily="sans-serif"
            fill={colors.range}
        >
            {textPoint.low > 33 ? `${rangeLow}🠜` : `🠞${rangeLow}`}
        </text>
        )}
        {(rangeHigh || rangeHigh === 0) && (
        <text
            className={styles.high}
            x={`${textPoint.high}%`}
            y="0"
            textAnchor={textPoint.high >= 67 ? "end" : "start"}
            dominantBaseline="text-before-edge"
            fontSize={fontsize-2}
            fontWeight="bold"
            fontFamily="sans-serif"
            fill={colors.range}
        >
            {textPoint.high >= 67 ? `${rangeHigh}🠜` : `🠞${rangeHigh}`}
        </text>
        )}

    </svg>
 );
};

export default InlineGraph;